import { getStoryBySlug } from "../story/requests";
import { Navbar } from "./entities";

const getNavbar = () => getStoryBySlug("global-settings/navbar").then(Navbar);

export { getNavbar };
